module.exports = __webpack_public_path__ + "img/icon-safe3.3d245c8f.png";